import React, { useEffect } from 'react'
import qs from 'qs'
import { hotjar } from 'react-hotjar'
import { useHistory } from 'react-router-dom'
import { Header } from 'components/Layout/components/Header'
import { Footer } from './components/Footer'
import { Content } from './components/Styled'
import { Helmet } from 'react-helmet'
import { localStorage } from 'lib/core/services/localStorage'

interface Props {
  children: JSX.Element
}

export const Layout = ({ children }: Props) => {
  const history = useHistory()
  const queryString = qs.parse(history.location.search.slice(1).toLowerCase())
  const cid = queryString.cid

  useEffect(() => {
    if (cid) {
      localStorage.set('extraHeaders', { 'last-contact-id': cid })
    }
  }, [cid])

  useEffect(() => {
    const hjid = 2362627
    const hjsv = 6
    if (process.env.REACT_APP_ENV === 'production') {
      hotjar.initialize(hjid, hjsv)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta name='trustpilot-one-time-domain-verification-id' content='f3cc7c0c-f8f2-4a1d-9e03-8902cb4a6b92' />
        <script type='text/javascript'>
          {`
            var biJsHost = (("https:" == document.location.protocol) ? "https://" : "http://");
            (function (d, s, id, tid, vid) {
              var js, ljs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
              js.src = biJsHost + "cdn.listrakbi.com/scripts/script.js?m=" + tid + "&v=" + vid;
              ljs.parentNode.insertBefore(js, ljs);
            })(document, 'script', 'ltkSDK', '${process.env.REACT_APP_LISTRAK_MERCHANT_ID}', '1');
          `}
        </script>
      </Helmet>
      <Header />
      <Content>
        {children}
      </Content>
      <Footer />
    </>
  )
}
